import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { TabsControllerPage } from '../tabs-controller/tabs-controller';


@Component({
  selector: 'page-splash',
  templateUrl: 'splash.html'
})
export class SplashPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController) {
    }
  goToTabsControllerPage(params){
    if (!params) params = {};
    this.navCtrl.push(TabsControllerPage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/splash/splash.ts